var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNetworkingBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52197 9.53711L11.3711 15.3795M19.503 23.0919L25.6683 24.845",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8641 16.936L26.2165 9.01733",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89702 9.625C10.0985 9.625 11.0725 8.70159 11.0725 7.5625C11.0725 6.42341 10.0985 5.5 8.89702 5.5C7.69555 5.5 6.72156 6.42341 6.72156 7.5625C6.72156 8.70159 7.69555 9.625 8.89702 9.625Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7509 9.625C28.9524 9.625 29.9264 8.70159 29.9264 7.5625C29.9264 6.42341 28.9524 5.5 27.7509 5.5C26.5494 5.5 25.5754 6.42341 25.5754 7.5625C25.5754 8.70159 26.5494 9.625 27.7509 9.625Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7509 27.5C28.9524 27.5 29.9264 26.5766 29.9264 25.4375C29.9264 24.2984 28.9524 23.375 27.7509 23.375C26.5494 23.375 25.5754 24.2984 25.5754 25.4375C25.5754 26.5766 26.5494 27.5 27.7509 27.5Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.248 27.5C16.8524 27.5 19.7744 24.7298 19.7744 21.3125C19.7744 17.8952 16.8524 15.125 13.248 15.125C9.64353 15.125 6.72156 17.8952 6.72156 21.3125C6.72156 24.7298 9.64353 27.5 13.248 27.5Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetworkingBlue);
export default __webpack_public_path__ + "static/media/Icon_Networking_Blue.9c071bfa526196fa44c984a4fbdf4800.svg";
export { ForwardRef as ReactComponent };